import styled from "styled-components";

export const JBOptInReminderHeaderMRGreenBox = styled.div`
    display: flex; 
    flex-direction: column; 
    align-items: center;
    background: linear-gradient(180deg, rgba(6, 47, 35, 0) 55.83%, #6D8F82 71.72%, #FFFFFF 90.37%); 
    height: 106px;
    width: 100%;
    justify-content: center;
      position: relative;
      bottom: -1px;
`;


